module.exports = __webpack_public_path__ + "static/pokoj-nr3-photo01-nikon_thumb-fac3158176926c81e827e42fb7ef7c54.jpg";